module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"Solde actuel","flags":["TRACK"],"track":"Current Balance"}}